/* eslint-disable no-undef */
import $ from "jquery";

const contactPersonArchive = () => {
  // used element
  const el = {
    selectCountry: ".js-contact-person-select-country",
    selectCity: ".js-contact-person-select-city",
    pagination: ".pagination-item a",
    pageName: "input[name='page_name']",
  };

  /**
   * run all functions
   */
  const init = () => {
    if ($(el.pageName).val() != "contact_person") return;

    onSelectCountryChainCity();
    onFilter();
    paginationAjax();
  };

  /**
   * doing ajax when pagination item clicked and rerender the result
   */
  const paginationAjax = () => {
    $(document).on("click", el.pagination, function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const $thisEl = $(e.target);
      const paginationUrl = $thisEl.attr("href");

      const pagedValue = extractPageNumber(paginationUrl);

      const filters = collectInput();
      updateCurrentUrl(filters, pagedValue);
      requestData(filters, pagedValue);
    });
  };

  const onSelectCountryChainCity = () => {
    $(document).on("change", el.selectCountry, function () {
      const locationId = $(this).val();
      const $selectCity = $(el.selectCity);
      if (locationId == "*") $selectCity.attr("disabled", true);
      let cities = "";

      locations.forEach((location) => {
        if (location.parent == locationId) {
          cities += `<option class="select-option select-option" value="${location.term_id}">${location.name} </option>`;
        }
      });

      $selectCity.find("option:not([value='*'])").each((i, el) => {
        el.remove();
      });

      if (cities != "") {
        $selectCity.append(cities);
        $selectCity.removeAttr("disabled");
      }
    });
  };

  const onFilter = () => {
    $(document).on(
      "change",
      `${el.selectCountry}, ${el.selectCity}`,
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const filters = collectInput();
        updateCurrentUrl(filters);
        requestData(filters);
      }
    );
  };

  const extractPageNumber = (url) => {
    // Extract the path from the URL
    const path = new URL(url).pathname;

    // Use a regular expression to match the page number in the path
    const match = path.match(/\/page\/(\d+)\/?$/);

    if (match) {
      // Return the matched page number
      return parseInt(match[1]);
    }

    // Default to 1 if page number is not found
    return 1;
  };

  const updateCurrentUrl = (filters, page = 1) => {
    // Get the current URL
    const url = new URL(window.location.href);

    console.log(containPageNumber(url.toString())); // eslint-disable-line no-console

    if (containPageNumber(url.toString())) {
      url.pathname = changePageNumber(url.pathname, page);
    } else {
      url.pathname += "page/" + page;
    }

    Object.keys(filters).forEach((key) => {
      if (filters[key] != "*") {
        url.searchParams.set(key, filters[key]);
      }
    });

    // Replace the current state in the browser history
    window.history.replaceState({}, document.title, url.toString());
  };

  /**
   * collect input from user
   */
  const collectInput = () => {
    // $(document).on("click", checkbox, function (e) {
    // eslint-disable-line no-unused-vars
    const filters = {};

    if ($(el.selectCountry).val() != "*") {
      filters.country = $(el.selectCountry).val();
    }

    if ($(el.selectCity).val() != "*") {
      filters.city = $(el.selectCity).val();
    }

    return filters;
  };

  const containPageNumber = (url) => {
    const pattern = /\/page\/\d+\/?/;
    return pattern.test(url);
  };

  const changePageNumber = (pathName, newPageNumber = 1) => {
    const pattern = /\/page\/(\d+)\/?/;
    const updatedUrl = pathName.replace(
      pattern,
      "/page/" + newPageNumber + "/"
    );

    return updatedUrl;
  };

  /**
   * request data to ajax
   * @param {array} input
   */
  const requestData = (input, paged = 1) => {
    // run loading animations
    // $(".wrapper-card-recepten").addClass("loading");

    let data = {
      // eslint-disable-next-line no-undef
      nonce: themeObj.ajax.nonce,
      // eslint-disable-next-line no-undef
      action: themeObj.ajax.contact_person.action,
      paged: paged,
    };

    if (input) {
      data.filters = input;
    }

    $.ajax({
      url: themeObj.ajaxUrl, // eslint-disable-line no-undef
      type: "POST",
      dataType: "json",
      data: data,
    })
      .done(function (r) {
        $(".wrapper-contact-personen").empty();
        $(".wrapper-contact-personen").append(r.data);
      })
      .always(function () {
        // stop loading animations
        $(".wrapper-contact-personen").removeClass("loading");
      });
  };

  init();
};

try {
  contactPersonArchive();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
